// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"776":"691e80355f448ec1","8059":"3cde8d1c2f4a1bf3"}[chunkId] + ".css";
};